import { FC } from 'react';
import { IonButton } from '@ionic/react';
import { createUseStyles } from 'react-jss';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { useSubscription } from '@meraki-internal/state';
import { AddMedicationLauncher } from './AddMedicationLauncher';
import { ImageIcon, KeyboardIcon } from '../../theme/Icons';
import { BottomSheetModal } from '../../components/BottomSheetModal';

const useStyles = createUseStyles({
    content: {
        padding: '28px 24px 32px',
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
        backgroundColor: '#fff'
    },
    title: {
        fontSize: 20,
        fontWeight: 600,
        color: 'var(--ion-color-dark)',
        marginBottom: 4,
        textAlign: 'center',
        letterSpacing: 'normal'
    },
    button: {
        '--padding-top': '20px',
        '--padding-bottom': '20px',
        '--padding-start': '20px',
        '--padding-end': '20px',
        height: 'auto',
        margin: 0
    },
    buttonInner: {
        display: 'flex',
        alignItems: 'center',
        gap: 14,
        width: '100%',
        textAlign: 'left'
    },
    buttonIcon: {
        flexShrink: 0
    },
    buttonText: {
        flex: 1
    },
    buttonLabel: {
        fontSize: 16,
        fontWeight: 600,
        marginBottom: 2,
        letterSpacing: 'normal'
    },
    buttonDescription: {
        fontSize: 13,
        fontWeight: 400,
        opacity: 0.85,
        textTransform: 'none',
        whiteSpace: 'normal',
        lineHeight: 1.4,
        letterSpacing: 'normal'
    }
});

export const AddMedicationChoiceSheet: FC = () => {
    const classes = useStyles();
    const launcher = useInstance(AddMedicationLauncher);
    useSubscription(() => launcher);

    return (
        <BottomSheetModal
            isOpen={launcher.state.isChoiceOpen}
            onDidDismiss={launcher.cancel}
            data-id="add-medication-choice-sheet"
        >
            <div className={classes.content}>
                <div className={classes.title}>Add a medication</div>

                <IonButton
                    expand="block"
                    color="primary"
                    className={classes.button}
                    onClick={launcher.chooseTakePhoto}
                    data-id="add-medication-photo-btn"
                >
                    <div className={classes.buttonInner}>
                        <div className={classes.buttonIcon}>
                            <ImageIcon color="light" customSize={22} />
                        </div>
                        <div className={classes.buttonText}>
                            <div className={classes.buttonLabel}>Take a Photo</div>
                            <div className={classes.buttonDescription}>
                                Snap the bottle or label and we'll pull in the details for you
                            </div>
                        </div>
                    </div>
                </IonButton>

                <IonButton
                    expand="block"
                    fill="outline"
                    color="primary"
                    className={classes.button}
                    onClick={launcher.chooseType}
                    data-id="add-medication-type-btn"
                >
                    <div className={classes.buttonInner}>
                        <div className={classes.buttonIcon}>
                            <KeyboardIcon color="primary" customSize={22} />
                        </div>
                        <div className={classes.buttonText}>
                            <div className={classes.buttonLabel}>Type It In</div>
                            <div className={classes.buttonDescription}>
                                Enter the medication details yourself
                            </div>
                        </div>
                    </div>
                </IonButton>
            </div>
        </BottomSheetModal>
    );
};
